import { GET_BILLING, GET_BILLINGAPPROVAL } from "resources/actionTypes";


const initialState = {
  userBilling: [],
  loading: false,
  error: null,
};

const initialStateApproval = {
  userBillingApproval: [],
  loading: false,
  error: null,
};

export function userBilling(state = initialState, action) {
  switch (action.type) {
    case GET_BILLING.GET_BILLING_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLING.GET_BILLING_SUCCESS:
      return {
        ...state,
        loading: false,
        userBilling: action.userBilling,
      };
    case GET_BILLING.GET_BILLING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userBillingApproval(state = initialStateApproval, action) {
  switch (action.type) {
    case GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        userBillingApproval: action.userBillingApproval,
      };
    case GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
